import React from 'react'

const hoverable = Component =>
  class Hoverable extends React.PureComponent {
    constructor() {
      super()
      this.state = { hover: false, recentlyTouched: false }
      this.onmouseenter = this.onmouseenter.bind(this)
      this.onmouseleave = this.onmouseleave.bind(this)
      this.ontouchend = this.ontouchend.bind(this)
      this.onclick = this.onclick.bind(this)
    }
    onmouseenter() {
      if (!this.state.recentlyTouched)
        this.setState({ ...this.state, hover: true })
      return (
        typeof this.props.onMouseEnter === 'function' &&
        this.props.onMouseEnter()
      )
    }
    onmouseleave() {
      this.setState({ ...this.state, hover: false })
      return (
        typeof this.props.onMouseLeave === 'function' &&
        this.props.onMouseLeave()
      )
    }
    ontouchend() {
      if (this.state.recentlyTouched) clearTimeout(this.state.recentlyTouched)
      const handle = setTimeout(() => {
        this.setState({ ...this.state, recentlyTouched: false })
      }, 1000)
      this.setState({ ...this.state, recentlyTouched: handle })
      if (typeof this.props.onClick === 'function') this.props.onClick()
      return (
        typeof this.props.onTouchEnd === 'function' && this.props.onTouchEnd()
      )
    }
    onclick() {
      if (
        !this.state.recentlyTouched &&
        typeof this.props.onClick === 'function'
      ) {
        this.props.onClick()
      }
    }
    render() {
      return (
        <Component
          hover={this.state.hover}
          {...this.props}
          onMouseEnter={this.onmouseenter}
          onMouseLeave={this.onmouseleave}
          onTouchEnd={this.ontouchend}
          onClick={this.onclick}
        />
      )
    }
  }

export default hoverable



// WEBPACK FOOTER //
// ./components/hoverable.js